/** DEV OPTS*/
/* @flow */

/* eslint-env node*/
/* eslint-disable no-console */
/*
 * Coach Amigo React Native App
 * https://github.com/facebook/react-native
 *
 */
import type { Props } from './../types/types';

import * as React from 'react';

import { View, IconButton, Text, rem } from './WebComponents';

import { getColor } from './../utils/Colors';

const CenterButton = (props: Props) => {
   if (!props) props = {};
   props = {
      sm: null,
      lg: null,
      labelText: '',
      visible: true,
      color: getColor.rgb('$blue'),
      iconColor: getColor.rgb('$white'),
      iconType: 'ionicon',
      iconName: 'Info',
      iconSize: rem(4),
      iconStyle: null,
      containerClassName: null,
      iconContainerStyle: { alignSelf: 'center', transform: [{ scaleX: 0.5 }] },
      size: rem(5),
      fontSize: rem(1.3),
      textStyle: null,
      onPress: null,
      style: null,
      activeOpacity: 0.4,
      ...props
   };

   if (!props.visible) return null;

   if (props.sm) {
      props = { ...props, fontSize: rem(1.2), size: rem(4), iconSize: rem(3) };
   }

   if (props.lg) {
      props = { ...props, fontSize: rem(2), size: rem(6), iconSize: rem(4.8) };
   }

   return (
      <View style={props.style} className={'view center-button'}>
         <IconButton
            iconSize={props.iconSize}
            name={props.iconName}
            type={props.iconType}
            color={props.color}
            iconColor={props.iconColor}
            containerClassName={props.containerClassName}
            size={props.size}
            iconStyle={props.iconStyle}
            containerStyle={props.iconContainerStyle}
            onPress={props.onPress}
            activeOpacity={props.activeOpacity}
         />
         <Text numberOfLines={1} style={{userSelect: 'none', color: props.color, fontSize: props.fontSize, marginTop: props.fontSize * 0.1, textAlign: 'center', ...props.textStyle }}>
            {props.labelText}
         </Text>
      </View>
   );
};

export default React.memo(CenterButton);
